import { Phone, MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";

export const FloatingCTA = () => {
  const waLink = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(
    SITE.whatsappMessage
  )}`;
  return (
    <div className="fixed bottom-6 left-4 z-50 flex flex-col gap-3">
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        className="flex items-center justify-center rounded-full bg-emerald-500 hover:bg-emerald-600 text-white shadow-lg shadow-emerald-500/30 transition-transform hover:scale-105"
        style={{ height: 56, width: 56 }}
      >
        <MessageCircle className="h-6 w-6" strokeWidth={2} />
      </a>
      <a
        href={`tel:${SITE.phoneRaw}`}
        data-testid="floating-call"
        aria-label="Call clinic"
        className="flex items-center justify-center rounded-full bg-blue-900 hover:bg-blue-800 text-white shadow-lg shadow-blue-900/30 transition-transform hover:scale-105"
        style={{ height: 56, width: 56 }}
      >
        <Phone className="h-5 w-5" strokeWidth={2} />
      </a>
    </div>
  );
};

export default FloatingCTA;
